module.exports = __webpack_public_path__ + "img/22.85ac746c.jpg";